
export const searchFormOption = function () {
    return [
        {
            prop: 'keyword',
            label: '关键字',
            type: 'input',
            placeholder: '请输入服务单编号/车牌号'
        },
    ]
}

// 修改编辑option
export const editFormOption = function () {
    return [
        {
            prop: 'tyName',
            label: '特约名称',
            type: 'input',
            placeholder: '请输入特约名称'
        },
        {
            prop: 'tyContent',
            label: '特约内容',
            type: 'select',
            placeholder: '请选择特约内容',
            options: []
        }
    ]
}

export default {}